import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-dd148a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

import { computed, ref, watchEffect } from "vue";
import { debug as d } from "debug";
import SessionSlide from "../../sessions/session-slide.vue";
import HeadFromModel from "../../head/head-from-model.vue";
import VisualPositioningCanvas from "../../sessions/visual-positioning-canvas.vue";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import {
  CmsRichText,
  CmsSessionSlideWithTextAndHead,
} from "../../../services/cms/cms-type-definitions";
import { csContext } from "../../../services/cs-context";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import SlideText from "./slide-text.vue";
import { useToggle } from "../../../composables/useToggle";


export default /*#__PURE__*/_defineComponent({
  __name: 'head-slide',
  props: {
    slice: {},
    index: {}
  },
  setup(__props: any, { expose: __expose }) {

const debug = d("cs.SoloHeadSlice");

const props = __props;

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

const isHeadLoaded = ref(false);

const prismicSlice = computed<CmsSessionSlideWithTextAndHead>(() => {
  return props.slice.prismicSlice as CmsSessionSlideWithTextAndHead;
});

const headType = computed(() => prismicSlice.value.primary?.head_type ?? "solo");

const id = computed(() => {
  switch (headType.value) {
    case "teamsolo":
    case "teamviewpoints":
      return csContext.currentTeam?.id;
    case "viewpoints":
    case "solo":
    default:
      return csContext.user.id;
  }
});

const noSoloText = computed(() => {
  switch (headType.value) {
    case "teamsolo":
      return "Your team needs at least two members with Solo reports before you can see this.";
    case "teamviewpoints":
      return "Your team needs at least two members with Viewpoints reports before you can see this.";
    case "viewpoints":
      return "You need at least two Viewpoints reports before you can see this.";
    case "solo":
    default:
      return "You need to complete your strengths mapping in the Foundations Session before you can see this.";
  }
});

const text = computed(() => {
  if (isHeadLoaded.value) {
    return prismicSlice.value.primary.text_body;
  }

  return noSoloText.value as unknown as CmsRichText;
});

const headLoaded = (hasData: boolean): void => {
  debug("headLoaded", headType.value, hasData);
  isHeadLoaded.value = hasData;
};

// These 3 refs need to be exposed so that cms-session can apply animations to them
const visual = ref<InstanceType<typeof HeadFromModel> | null>(null);
const slide = ref<InstanceType<typeof SessionSlide> | null>(null);
const visualDiv = computed(() => slide?.value?.visualDiv);

// once the strengths mapping has finished -> get the data for the head
watchEffect(() => {
  if (cmsSessionStore.hasFinishedMapping.strengths) {
    visual.value?.getHeadModelData();
  }
});

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

__expose({
  visualDiv,
  visual,
  slide,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SessionSlide, {
    ref_key: "slide",
    ref: slide,
    id: 'slide' + props.index,
    "visual-position": "fixed",
    class: _normalizeClass({
      'slide-after-activity': !_unref(isDisplayed),
      'submitted-mapping': _unref(isDisplayed),
    }),
    "data-test": `session-slide-${props.index}`
  }, {
    text: _withCtx(() => [
      _createVNode(SlideText, {
        text: text.value,
        "data-test": `${headType.value}-head-slice-text`
      }, null, 8, ["text", "data-test"])
    ]),
    visual: _withCtx(() => [
      _createVNode(VisualPositioningCanvas, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            id: `${headType.value}-head-slice-${props.index}`,
            class: "head-container"
          }, [
            _createVNode(HeadFromModel, {
              ref_key: "visual",
              ref: visual,
              headId: id.value,
              whiteBackground: true,
              kind: headType.value,
              "show-tooltips": true,
              "animate-entrance": false,
              onOnDataLoaded: headLoaded,
              containerForTooltips: `#${headType.value}-head-slice-${props.index}`,
              "data-test": `${headType.value}-head`
            }, null, 8, ["headId", "kind", "containerForTooltips", "data-test"])
          ], 8, _hoisted_1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "class", "data-test"]))
}
}

})